import { render, staticRenderFns } from "./embed-modal.vue?vue&type=template&id=dac3b76c&scoped=true&"
import script from "./embed-modal.vue?vue&type=script&lang=js&"
export * from "./embed-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac3b76c",
  null
  
)

export default component.exports